import API_PATHS from './apiPaths';
import NetworkService from './NetworkService';

export default {...NetworkService, API: {...API_PATHS}};
